import React from "react";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    label: string,
    correct?: boolean,
}

type Form = {
    id: string,
    question: string,
    answers: Array<Item>
}

const TaskGame4: React.FunctionComponent<Props> = () => {

    const form : Form[] = [
        {   
            id: 'a1',            
            question: '1. Jednym z symboli nowoczesności II Rzeczpospolitej była tzw. luxtorpeda, czyli luksusowe i bardzo szybkie pociągi najnowszej (wówczas) generacji. Jak Ci się wydaje, ile takich cudów techniki mogło jeździć po polskich torach w latach 30.?',
            answers: [
                {
                    label: 'a) mniej niż 10',
                    correct: true
                },
                {
                    label: 'b) ponad 50'
                },
                {
                    label: 'c) prawie 100'
                },
            ]
        },
        {   
            id: 'a2',            
            question: '2. W II Rzeczpospolitej coraz większą popularność zdobywało kino. Jak sądzisz, jaki jego rodzaj był w przedwojennej Polsce szczególnie silnie rozwinięty – i to na skalę światową?',
            answers: [
                {
                    label: 'a) filmy historyczne' 
                },
                {
                    label: 'b) filmy żydowskie',
                    correct: true
                },
                {
                    label: 'c) filmy fantastyczne'
                },
            ]
        },
        {   
            id: 'a3',            
            question: '3. Jako wielki sukces przedwojennej Polski wymienia się stworzenie systemu szkolnego. Jak myślisz, które z poniższych zdań poprawnie go charakteryzuje: ',
            answers: [
                {
                    label: 'a) wszystkie szkoły były bezpłatne, ale wielu robotników i chłopów nie chciało kształcić swoich dzieci'
                },
                {
                    label: 'b) szkoły średnie były płatne, ale dzięki stypendiom państwowym nawet biedniejsi uczniowie mogli je najczęściej ukończyć'                    
                },
                {
                    label: 'c) szkoły średnie były płatne i tylko niewielki odsetek dzieci z biednych rodzin docierał do matury',
                    correct: true
                },
            ]
        },
        {   
            id: 'a4',            
            question: '4. Obecnie bardzo wiele mówi się o tzw. żołnierzach wyklętych i podziemiu sprzeciwiającym się po drugiej wojnie światowej władzy komunistów. Jak myślisz, jaki procent Polaków i Polek angażował się w latach 1944–1956 w takie działania (z bronią w ręku lub na inny sposób)?',
            answers: [
                {
                    label: 'a) mniej niż 1%;',
                    correct: true
                },
                {
                    label: 'b) więcej niż 5%'
                },
                {
                    label: 'c) ok. 8%.',
                    
                }
            ]
        }
    ]

    return (
        <div className="task-game-4">
            <div className="forms"> 
                <FormItem form={form[0]}></FormItem>              
                <FormItem form={form[1]}></FormItem>
                <FormItem form={form[2]}></FormItem>
                <FormItem form={form[3]}></FormItem>
            </div>           
        </div>
    )
}



const FormItem: React.FunctionComponent<{
    form: Form,
}> = ({ form, children }) => {
    return (
        <div className="form-item">
            <p>{form.question}</p>
            <ul>
                {form.answers.map((i, index) => {
                    return (
                        <li key={index}>
                            <label className={`${i.correct? 'correct' : 'wrong'}`}>
                                <input type="radio" name={`radio-${form.id}`} />
                                <div className="game-element">
                                    {i.label}
                                </div>
                            </label>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default TaskGame4;